var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddIconEntity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 10.0625H12.9375V1.4375C12.9375 1.05625 12.786 0.690618 12.5165 0.421034C12.2469 0.151451 11.8812 0 11.5 0C11.1188 0 10.7531 0.151451 10.4835 0.421034C10.214 0.690618 10.0625 1.05625 10.0625 1.4375V10.0625H1.4375C1.05625 10.0625 0.690618 10.214 0.421034 10.4835C0.151451 10.7531 0 11.1188 0 11.5C0 11.8812 0.151451 12.2469 0.421034 12.5165C0.690618 12.786 1.05625 12.9375 1.4375 12.9375H10.0625V21.5625C10.0625 21.9437 10.214 22.3094 10.4835 22.579C10.7531 22.8486 11.1188 23 11.5 23C11.8812 23 12.2469 22.8486 12.5165 22.579C12.786 22.3094 12.9375 21.9437 12.9375 21.5625V12.9375H21.5625C21.9437 12.9375 22.3094 12.786 22.579 12.5165C22.8486 12.2469 23 11.8812 23 11.5C23 11.1188 22.8486 10.7531 22.579 10.4835C22.3094 10.214 21.9437 10.0625 21.5625 10.0625Z",
    fill: "#1B1B1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconEntity);
export default __webpack_public_path__ + "static/media/addIconEntity.61ab955d6c5fd6c0a39b926ffcc195cd.svg";
export { ForwardRef as ReactComponent };